import { createAsyncThunk } from "@reduxjs/toolkit";
import { iGenericResponse, iProductReportResponse, iStateMessage, REDUCER_NAME } from "./Types";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { productReportData } from "@/services/api/cresivoxServer";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getProductReportData = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<iProductReportResponse> | null,
  Record<string, any>, // 👈 accept query params
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getProductReportData"),
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await productReportData.getProductReportData(queryParams);

      if (!response) {
        // @ts-expect-error
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        if (data && data.data?.overviewChart) {
          return {
            httpStatusCode,
            data: { overviewChart: data.data },
            message,
          };
        } else {
          //@ts-expect-error
          return rejectWithValue({ message: "overviewChart not found in response" });
        }
      }
// @ts-expect-error
      return rejectWithValue({ message });
    } catch (error) {
      console.error("🚀 ~ getProductReportData error:", error);
      // @ts-expect-error
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

